(function ($) {
  'use strict';

  var TRANSITION_TIMING = 250;
  var $nav = $('.horizontal-strip-nav');
  var $backToPrev = $('.horizontal-strip-nav .back-to-prev');
  var $menuToggle = $('.strip-wrapper');
  var label = 'Open Horizontal Navigation';
  var labelClose = 'Close Horizontal Navigation';

  var openMenu = function () {
    $nav.css('style', 'block').fadeIn(TRANSITION_TIMING);
    $('.strip-wrapper').addClass('open');
    // bind a close menu trigger to scroll event to automatically close the menu when page is scrolled
    $(window).on('scroll.closeMenu', function () {
      $menuToggle.trigger('click');
    });
  };

  var closeMenu = function () {
    $nav.css('style', 'none').fadeOut(TRANSITION_TIMING);
    $('.strip-wrapper').removeClass('open');
    $(window).unbind('scroll.closeMenu');
  };

  var initHorizontalStrip = function () {
    if ($('.cc--horizontal-strip').length) {
      $('body').addClass('horizontal-nav');
    }

    $('.horizontal-strip-nav .m--menu li').each(function () {
      if ($(this).hasClass('menu-item--active-trail')) {
        var $btnLabel = $(this).find('.expand').first().text().trim();
        $(this).addClass('is-open');
        $(this).find('.expand').first().addClass('opened').attr('aria-label', 'Close Sub Menu for ' + $btnLabel).attr('aria-expanded', 'true');
        $(this).parents('.menu-item').closest('.submenus-wrapper').addClass('open');
        $(this).closest('.horizontal-strip-nav').addClass('open');
      }
    });

    // Menu Toggle click/tap
    $menuToggle.on('click', function (e) {
      e.preventDefault();

      if (!$(this).hasClass('is-active')) {
        openMenu();
        $(this).addClass('is-active');
        $('html').addClass('horizontal-nav-open');
      } else {
        closeMenu();
        $(this).removeClass('is-active');
        $('html').removeClass('horizontal-nav-open');
      }

      if ($(this).hasClass('is-active')) {
        $menuToggle.attr('aria-label', labelClose);
        $menuToggle.attr('aria-expanded', 'true');
        $('.horizontal-strip-toggle').attr('aria-label', labelClose);
        $('#l--main-header').siblings().each(function (i, el) {
          el.inert = true;
        });
      } else {
        $menuToggle.attr('aria-label', label);
        $menuToggle.attr('aria-expanded', 'false');
        $('.horizontal-strip-toggle').attr('aria-label', label);
        $('#l--main-header').siblings().each(function (i, el) {
          el.inert = false;
        });
      }
    });

    $backToPrev.on('click', function (e) {
      e.preventDefault();
      var $this = $(this);

      $this.closest('li').children('.link-arrow-wrapper').find('button.opened').click();
    });

    var $menuItemBtn = $('.horizontal-strip-nav .link-arrow-wrapper .expand');

    $menuItemBtn.on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $btnLabel = $(this).text().trim();
      var $liParent = $this.closest('li');
      var $ulParent = $this.closest('ul');

      // Close menu if you clicked on the same opened button
      if ($liParent.hasClass('is-open')) {
        $liParent.removeClass('is-open');
        $this.removeClass('opened').attr('aria-label', 'Display Sub Menu for ' + $btnLabel);
        $this.attr('aria-expanded', 'false');
        $liParent.children('.submenus-wrapper').fadeOut(150);
        $this.closest('.submenus-wrapper').removeClass('open');

        if ($ulParent.hasClass('m--menu')) {
          $ulParent.parent().removeClass('open');
        }
        // Remove class background color if you click on first level menu
      } else {
        // Check if there is any other already opened menu item and close it
        if ($ulParent.children('li.is-open')) {
          $ulParent.children('li.is-open').children('.link-arrow-wrapper').find('button').click();
        }

        // Simply open submenu on click
        $liParent.addClass('is-open');
        $this.attr('aria-expanded', 'true');
        $this.addClass('opened').attr('aria-label', 'Close Sub Menu for ' + $btnLabel);
        $liParent.children('.submenus-wrapper').fadeIn(TRANSITION_TIMING);
        $this.closest('.submenus-wrapper').addClass('open');

        if ($ulParent.hasClass('m--menu')) {
          $ulParent.parent().addClass('open');
        }
      }
    });
  };

  window.DP.behaviors.horizontalStrip = {
    attach: function (context) {
      $(context).find('.cc--horizontal-strip').once('horizontalStrip').each(function () {
        initHorizontalStrip.apply();
      });
    },
  };
})(jQuery);
